import React from "react";
import "./Educations.css";
import DegreeCard from "../../components/degreeCard/DegreeCard.js";
import { degrees } from "../../portfolio";
import FadeWrapper from "../../components/FadeWrapper/FadeWrapper.js";

function Educations(props) {
  const theme = props.theme;

  return (
    <div className="main" id="educations">
      <div className="educations-header-div">
        <FadeWrapper direction="top" duration={2} distance={20}>
          <h1 className="educations-header" style={{ color: theme.text }}>
            Degrees Received
          </h1>
        </FadeWrapper>
      </div>
      <div className="educations-body-div">
        {degrees.degrees.map((degree) => {
          return <DegreeCard degree={degree} theme={theme} />;
        })}
      </div>
    </div>
  );
}

export default Educations;
